import { basisParam, getBasis } from "@app/lib/basis";
import { getPerspectiveId } from "@app/lib/perspective";
import PnlPage, { pnlQuery } from "@app/pages/pnl/pnl-page";
import type { pnlPage_Query } from "@app/queries/pnlPage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/pnl")({
  // All-time data: the page's own year navigator picks which year's 12 months to
  // show (like the categorization overview), so the global date range is not threaded.
  loader: () =>
    loadQuery<pnlPage_Query>(
      environment,
      pnlQuery,
      {
        perspectiveId: getPerspectiveId() ?? undefined,
        basis: basisParam(getBasis()) ?? undefined,
      },
      { fetchPolicy: "store-or-network" }
    ),
  head: () => pageHead("P&L"),
  component: PnlRoute,
});

function PnlRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary
      fallback={<div className="p-6 text-red-500">Error loading P&L</div>}
    >
      <Suspense
        fallback={
          <div className="p-6 text-gray-500">Building the P&L statement...</div>
        }
      >
        <PnlPage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
